import React from "react";
import { Col, Row } from "antd";
import { useParams } from "react-router-dom";

import useMapData from "../../utils/useMapData";

import OwlCarouselCmp from "../OwlCarousel/OwlCarousel";
import { VerticalText } from "../../StyledCmp";

const Amenities = React.forwardRef((props, ref) => {
  const { propertyId } = useParams();
  const resultList = useMapData(propertyId);

  return (
    <>
      <Row ref={ref} className="ammenities_wrapper">
        <div id="horizontal_text">
          <h1 style={{ color: resultList.themeColor }}>Amenities</h1>
        </div>
        <Col lg={22}>
          <OwlCarouselCmp />
        </Col>
        <Col lg={1}>
          <div className="vertical_text">
            <VerticalText>Amenities</VerticalText>
          </div>
        </Col>
      </Row>
    </>
  );
});

export default Amenities;
